import React, { PureComponent } from 'react';
import styled from 'styled-components';
import downloadLogo from '@assets/logo-download.svg';

const Logo = styled.img`
  height: 30px;
  margin-top: 5px;
`;

export default class DownloadLogo extends PureComponent {
  render() {
    return <Logo src={downloadLogo} {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./components/atoms/DownloadLogo.js